module.exports = __webpack_public_path__ + "static/img/userCallBackDiscountMax.ab183e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/callback/userCallBackDiscountMax.svg
// module id = xxjk
// module chunks = 0